import { loadConfig } from './config';
import { handleCallback, getCurrentUser, signIn } from './auth';
import { startApp } from './app';

async function bootstrap() {
  await loadConfig();
  if (window.location.pathname === '/callback') {
    await handleCallback();
    window.history.replaceState({}, '', '/');
  }
  const user = await getCurrentUser();
  if (!user) {
    await signIn();
    return;
  }
  startApp();
}

bootstrap().catch((e) => console.error('Bootstrap failed', e));
